// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagScanComments extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagViewModel
	 */
	public render(data: SmartTagModel, version?: string): string {
		this.getData(data);
		
		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagModel): void {
		const title = data.title || data.subCategory || '';
		const notes = data.additionalData.filter(item => item.name === 'Notes') || [];
		const description = notes[0]?.value || '';

		if (title !== '') {
			this.title = `<span title="${title}">${title}</span>`;
		}
		if (description !== '') {
			this.addText(`<span title="${description}">${description}</span>`);
		}
	}
}
